export default __webpack_public_path__ + "static/media/upload_icon.70cc9636.svg";